export const LogoMark = ({ className = "h-11 w-auto", onDark = false }) => (
  <img
    src={onDark ? "/logo-mark-light.png" : "/logo-mark.png"}
    alt="VR Vision Projects logo"
    className={className}
  />
);

export const Logo = ({ dark = true, markClass = "h-11 w-auto", textSize = "text-lg", textClassName = "" }) => (
  <span className="logo-shine flex items-center gap-3">
    <LogoMark className={markClass} onDark={!dark} />
    <span className={`leading-none ${textClassName}`}>
      <span className={`block font-display font-black tracking-tight ${textSize} ${dark ? "text-navy" : "text-white"}`}>
        VR VISION <span className="text-brand">PROJECTS</span>
      </span>
      <span className={`block text-[9px] font-semibold tracking-[0.35em] mt-1 ${dark ? "text-subtle" : "text-slate-400"}`}>
        ENGINEERING SERVICES
      </span>
    </span>
  </span>
);
